import { makeStyles } from '@material-ui/core/styles'

export const priorityMeta = {
  rush: { label: 'Rush', color: '#b71c1c', textColor: '#fff' },
  high: { label: 'High', color: '#ef6c00', textColor: '#fff' },
  normal: { label: 'Normal', color: '#1565c0', textColor: '#fff' },
  low: { label: 'Low', color: '#546e7a', textColor: '#fff' }
}

export const scheduleMeta = {
  overdue: { label: 'Overdue', color: '#c62828', borderColor: '#ef5350' },
  never_done: { label: 'Never Done', color: '#ad1457', borderColor: '#e91e63' },
  needs_completion: { label: 'Ticket Cleanup', color: '#7b1fa2', borderColor: '#9c27b0' },
  due_soon: { label: 'Due Soon', color: '#e65100', borderColor: '#ff9800' },
  ok: { label: 'OK', color: '#2e7d32', borderColor: '#4caf50' },
  ignored: { label: 'Ignored', color: '#78909c', borderColor: '#9e9e9e' }
}

export const queueStatusMeta = {
  draft: { label: 'Draft', color: '#8d6e63', textColor: '#fff' },
  ready: { label: 'Ready', color: '#2e7d32', textColor: '#fff' },
  assigned: { label: 'Assigned', color: '#6a1b9a', textColor: '#fff' },
  'in-progress': { label: 'In Progress', color: '#1565c0', textColor: '#fff' },
  partial: { label: 'Partial', color: '#f9a825', textColor: '#1f1f1f' },
  completed: { label: 'Completed', color: '#00838f', textColor: '#fff' }
}

export const dyeMeta = {
  yes: { label: 'Blue Dye: Yes', color: '#1e88e5', textColor: '#fff' },
  no: { label: 'Blue Dye: No', color: '#90a4ae', textColor: '#1f1f1f' },
  unspecified: { label: 'Blue Dye: ?', color: '#fdd835', textColor: '#1f1f1f' }
}

export const packetMeta = {
  ready: { label: 'Ready', color: '#43a047', textColor: '#fff' },
  missing: { label: 'Needs Info', color: '#f9a825', textColor: '#1f1f1f' }
}

export const useV3Styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    maxHeight: '100vh',
    minHeight: 0,
    overflow: 'hidden',
    background: '#fafbfc'
  },
  statsBar: {
    display: 'flex',
    gap: 6,
    padding: '10px 16px',
    background: '#fff',
    borderBottom: '1px solid #e8e8e8',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  filterBar: {
    padding: '8px 16px',
    background: '#fff',
    borderBottom: '1px solid #e8e8e8',
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  mainContent: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  },
  contentShell: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  },
  workspacePane: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden'
  },
  queuePanel: {
    width: 340,
    borderRight: '1px solid #e8e8e8',
    minHeight: 0,
    overflowY: 'auto',
    background: '#fff'
  },
  detailPanel: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2.5, 3),
    background: '#fafbfc'
  },
  detailStateCard: {
    minHeight: 260,
    padding: theme.spacing(3),
    background: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: 10,
    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)'
  },
  detailEmptyState: {
    minHeight: 320,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
    background: '#fff',
    border: '1px dashed #d7dee2',
    borderRadius: 12
  },
  detailSkeletonLine: {
    height: 12,
    borderRadius: 999,
    marginBottom: 10,
    background: 'linear-gradient(90deg, #eef2f4 0%, #f8fafb 50%, #eef2f4 100%)'
  },
  detailSkeletonFacts: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(120px, 1fr))',
    gap: 14,
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(120px, 1fr))'
    }
  },
  detailSkeletonFact: {
    padding: theme.spacing(1.5),
    border: '1px solid #edf0f2',
    borderRadius: 8
  },
  activityPanel: {
    width: 360,
    flexShrink: 0,
    borderLeft: '1px solid #e8e8e8',
    minHeight: 0,
    overflowY: 'auto',
    background: '#f7f9f8',
    [theme.breakpoints.down('md')]: {
      width: 310
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  activityPanelHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 14px',
    background: '#fff',
    borderBottom: '1px solid #e8e8e8'
  },
  activityPanelControls: {
    padding: '10px 12px 6px 12px',
    background: '#fff'
  },
  activityPanelHint: {
    display: 'block',
    padding: '0 12px 10px 12px',
    color: '#78909c',
    background: '#fff',
    borderBottom: '1px solid #eef1f2'
  },
  activityItem: {
    padding: '12px 14px',
    borderBottom: '1px solid #e9edef',
    background: '#fff',
    cursor: 'pointer',
    '&:hover': {
      background: '#f5f9ff'
    }
  },
  activityItemCompact: {
    padding: '8px 0',
    borderBottom: '1px solid #f1f3f4',
    cursor: 'pointer',
    '&:hover': {
      background: '#fafafa'
    }
  },
  activityIcon: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  activityTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#263238',
    lineHeight: 1.25
  },
  activitySite: {
    display: 'block',
    color: '#607d8b',
    lineHeight: 1.2
  },
  activityBody: {
    color: '#455a64',
    fontSize: 12,
    marginTop: 6,
    lineHeight: 1.35
  },
  activityMeta: {
    display: 'block',
    color: '#90a4ae',
    marginTop: 6,
    fontSize: 10
  },
  activityPhotos: {
    display: 'flex',
    gap: 6,
    marginTop: 8,
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  activityPhoto: {
    width: 54,
    height: 42,
    objectFit: 'cover',
    borderRadius: 6,
    border: '1px solid #dde5e8',
    background: '#eceff1'
  },
  activityPhotoMore: {
    minWidth: 34,
    height: 28,
    borderRadius: 14,
    background: '#eceff1',
    color: '#546e7a',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 700
  },
  footerBar: {
    position: 'sticky',
    bottom: 0,
    zIndex: 4,
    borderTop: '1px solid #e8e8e8',
    background: '#fff',
    boxShadow: '0 -4px 14px rgba(15, 23, 42, 0.06)'
  },
  // Queue card styles
  queueCard: {
    padding: '10px 14px',
    borderBottom: '1px solid #f0f0f0',
    cursor: 'pointer',
    borderLeft: '3px solid transparent',
    '&:hover': {
      background: '#f9f9f9'
    }
  },
  queueCardSelected: {
    background: '#f5f9ff',
    borderLeftColor: '#1976d2 !important'
  },
  queueCardName: {
    fontWeight: 600,
    color: '#333',
    fontSize: 13
  },
  queueCardAddress: {
    fontSize: 11,
    color: '#999',
    marginTop: 1
  },
  queueCardMeta: {
    display: 'flex',
    gap: 6,
    marginTop: 4,
    alignItems: 'center'
  },
  queueCardAreas: {
    display: 'flex',
    gap: 8,
    marginTop: 4,
    alignItems: 'center'
  },
  queueCardActivity: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 6
  },
  queueActivityBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '2px 6px',
    fontSize: 9,
    fontWeight: 700,
    lineHeight: 1.2
  },
  // Detail panel styles
  detailHeader: {
    marginBottom: theme.spacing(2)
  },
  quickFacts: {
    display: 'flex',
    gap: 16,
    padding: '12px 16px',
    background: '#fff',
    borderRadius: 8,
    border: '1px solid #e8e8e8',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap'
  },
  quickFactItem: {
    borderLeft: '1px solid #eee',
    paddingLeft: 16,
    '&:first-child': {
      borderLeft: 'none',
      paddingLeft: 0
    }
  },
  quickFactTicketValue: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 2,
    minHeight: 22,
    flexWrap: 'wrap'
  },
  quickFactTicketLink: {
    fontSize: 13,
    fontWeight: 700,
    lineHeight: '18px',
    display: 'inline-block',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    },
    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.18)',
      borderRadius: 4
    }
  },
  quickFactTicketDate: {
    color: '#6f8791',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '18px'
  },
  actionBar: {
    display: 'flex',
    gap: 8,
    marginBottom: theme.spacing(2)
  },
  collapsibleSection: {
    background: '#fff',
    borderRadius: 8,
    border: '1px solid #e8e8e8',
    marginBottom: theme.spacing(1.25)
  },
  sectionHeader: {
    padding: '10px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none'
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#333'
  },
  sectionBody: {
    padding: '0 14px 12px 14px'
  }
}))
